import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.2929 6.70711C16.6834 7.09763 17.3166 7.09763 17.7071 6.70711C18.0976 6.31658 18.0976 5.68342 17.7071 5.29289L12.7071 0.292893C12.3166 -0.0976311 11.6834 -0.0976311 11.2929 0.292893L6.29289 5.29289C5.90237 5.68342 5.90237 6.31658 6.29289 6.70711C6.68342 7.09763 7.31658 7.09763 7.70711 6.70711L12 2.41421L16.2929 6.70711Z M7.70711 17.2929C7.31658 16.9024 6.68342 16.9024 6.29289 17.2929C5.90237 17.6834 5.90237 18.3166 6.29289 18.7071L11.2929 23.7071C11.6834 24.0976 12.3166 24.0976 12.7071 23.7071L17.7071 18.7071C18.0976 18.3166 18.0976 17.6834 17.7071 17.2929C17.3166 16.9024 16.6834 16.9024 16.2929 17.2929L12 21.5858L7.70711 17.2929Z"
  }));
});
var NavigationChevronNav = AbstractIcon.withComponent(Icon);
NavigationChevronNav.displayName = 'NavigationChevronNav';
export default NavigationChevronNav;